<!-- 平台商品对账单 -->
<template>
  <div class="container" ref="containerRef">
    <div class="search-box" ref="searchBoxRef">
      <div class="search-form">
        <el-form :inline="true">
          <!-- 客户名称、供应商名称、订单号、订单状态、结算状态、缴费状态、下单时间、完成收货时间 -->
          <el-form-item>
            <el-input
              v-model="clientName"
              style="width: 140px"
              size="small"
              placeholder="客户名称"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="province"
              style="width: 120px"
              size="small"
              clearable
              placeholder="请选择省"
              @change="provinceBtn"
            >
              <el-option
                v-for="(item, index) in provinceData"
                :key="index"
                :label="item.rname"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="city"
              style="width: 120px"
              size="small"
              clearable
              placeholder="请选择市"
              @change="cityBtn"
            >
              <el-option
                v-for="(item, index) in cityData"
                :key="index"
                :label="item.rname"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="area"
              style="width: 120px"
              size="small"
              clearable
              placeholder="请选择区"
              @change="areaBtn"
            >
              <el-option
                v-for="(item, index) in areaData"
                :key="index"
                :label="item.rname"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <!-- 客户类型 -->
            <mutilSelect
              :ids.sync="clientIds"
              type="customer"
              title="客户类型"
            ></mutilSelect>
          </el-form-item>
          <!-- <el-form-item>
            <el-input
              v-model="supplierName"
              style="width: 140px"
              size="small"
              placeholder="供应商名称"
            ></el-input>
          </el-form-item> -->
          <el-form-item>
            <!-- 供应商名称 -->
            <mutilSelect
              :ids.sync="supplierIds"
              type="supplier"
              title="供应商名称"
            ></mutilSelect>
          </el-form-item>
          <!-- 商品类型 -->
          <el-form-item>
            <el-select
              v-model="businessType"
              style="width: 120px"
              size="small"
              placeholder="商品类型"
              clearable
            >
              <el-option label="普药" value="1"></el-option>
              <el-option label="贴敷" value="2"></el-option>
              <el-option label="外部控销" value="5"></el-option>
              <el-option label="多控销订单" value="6"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="goodsName"
              style="width: 140px"
              size="small"
              placeholder="商品名称"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="orderCode"
              style="width: 160px"
              size="small"
              placeholder="订单号"
            ></el-input>
          </el-form-item>
          <!-- 订单状态 -->
          <el-form-item>
            <el-select
              v-model="orderStatus"
              style="width: 120px"
              size="small"
              placeholder="订单状态"
            >
              <el-option
                :label="item.label"
                :value="item.value"
                v-for="(item, index) in statusArr"
                :key="index"
              ></el-option>
            </el-select>
          </el-form-item>
          <!-- 缴费状态 -->
          <el-form-item>
            <el-select
              v-model="payFeesStatus"
              style="width: 120px"
              size="small"
              placeholder="缴费状态"
            >
              <el-option label="未缴费" value="0"></el-option>
              <el-option label="已缴费" value="1"></el-option>
            </el-select>
          </el-form-item>
          <!-- 下单时间 时间区间-->
          <el-form-item label="下单时间">
            <el-date-picker
              placeholder="选择日期"
              v-model="orderDate"
              format="yyyy-MM-dd HH:mm:ss"
              size="small"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="完成收货时间">
            <el-date-picker
              placeholder="选择日期"
              v-model="finishDate"
              format="yyyy-MM-dd HH:mm:ss"
              size="small"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="search-btn">
        <el-button type="primary" size="small" @click="handleSearch"
          >搜索</el-button
        >
        <el-button size="small" @click="handleReset">重置</el-button>
        <el-button type="primary" size="small" @click="handleExport"
          >导出</el-button
        >
      </div>
    </div>
    <priceTotalNotice :count="noticeCount" :list="noticeArr"></priceTotalNotice>
    <div class="table-box">
      <!-- 下单时间 完成收货时间 订单编号 订单状态 订单总金额（元）分账金额（元）应收总金额（元）收入技术服务费（元）收入推广服务费（元）客户名称 运费（元）平台补贴（元） 退款金额（元） 订单技术服务费（元） 订单推广服务费（元） 结算金额（元）供应商名称 供应商税号 供应商地址 供应商电话 供应商开户银行 供应商银行账号 供应商联系人 供应商联系电话 结算状态 缴费状态 -->
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        ref="tableBoxRef"
        :height="tableBoxHeight"
        v-loading="loading"
      >
        <template v-for="(item, index) in tableColumns">
          <el-table-column
            v-if="item.slot"
            :key="index"
            :label="item.label"
            :width="item.width"
            :align="item.align"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span v-if="item.prop === 'orderStatus'">{{
                orderStatusMap[scope.row.orderStatus]
              }}</span>
              <span v-if="item.prop === 'settleAccountsStatus'">{{
                settleAccountsStatusMap[scope.row.settleAccountsStatus]
              }}</span>
              <span v-if="item.prop === 'payFeesStatus'">{{
                payFeesStatusMap[scope.row.payFeesStatus]
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-else
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :align="item.align"
            :show-overflow-tooltip="true"
          >
          </el-table-column>
        </template>
      </el-table>
    </div>
    <div class="pagination-box" v-if="tableData.length">
      <el-pagination
        layout="prev, pager, next , jumper, sizes, total"
        :total="page.total"
        :page-size="page.size"
        :current-page="page.current"
        background
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
        :page-sizes="[20, 50, 100]"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import {
  queryProductMonthlyStatementPage,
  queryProductMonthlyStatementCollect,
  productMmonthlyStatementExport,
} from "@/api/statistics";
import {
  regionProvince,
  regionCity,
  regionArea,
} from "@/api/merchantsettlement/index";
import mutilSelect from "./components/mutilSelect.vue";
import priceTotalNotice from "@/components/priceTotalNotice";
import _ from "lodash";
export default {
  name: "plGoodsStatement",
  components: {
    mutilSelect,
    priceTotalNotice,
  },
  data() {
    return {
      containerRef: null,
      searchBoxRef: null,
      tableBoxRef: null,
      tableBoxHeight: 200,
      clientName: "",
      province: "",
      city: "",
      area: "",
      provinceData: [],
      cityData: [],
      areaData: [],
      supplierName: "",
      goodsName: "",
      orderCode: "",
      orderStatus: "",
      settleAccountsStatus: "",
      payFeesStatus: "",
      orderDate: "",
      finishDate: "",
      loading: false,
      statusArr: [
        { value: "", label: "全部" },
        { value: "2", label: "待发货" },
        { value: "3", label: "配送中" },
        { value: "5", label: "已取消" },
        { value: "8", label: "已收货" },
        { value: "9", label: "已完成" },
        { value: "12", label: "待确款" },
      ],
      page: {
        current: 1,
        size: 20,
        total: 0,
      },
      // 订单状态：1.待付款,2.待发货, 3.配送中,4.资质待审核,5.交易取消, 6申请退款,7.已退款,8.已签收, 9.已完成, 00.不展示订单,11-订单待审核,10-待确款
      orderStatusMap: {
        1: "待付款",
        2: "待发货",
        3: "配送中",
        4: "已完成",
        5: "交易取消",
        6: "申请退款",
        7: "已退款",
        8: "已收货",
        9: "已完成",
        "00": "不展示订单",
        11: "订单待审核",
        12: "待确款",
      },
      // 结算状态:0未结算1已结算
      settleAccountsStatusMap: {
        0: "未结算",
        1: "已结算",
      },
      // 缴费状态:0未支付1已支付
      payFeesStatusMap: {
        0: "未缴费",
        1: "已缴费",
      },
      tableColumns: [
        {
          width: 150,
          align: "center",
          label: "客户名称",
          prop: "clientName",
        },
        {
          width: 100,
          align: "center",
          label: "客户省",
          prop: "provinceName",
        },
        {
          width: 100,
          align: "center",
          label: "客户市",
          prop: "cityName",
        },
        {
          width: 100,
          align: "center",
          label: "客户区县",
          prop: "areaName",
        },
        {
          width: 100,
          align: "center",
          label: "客户类型",
          prop: "typeName",
        },
        {
          width: 100,
          align: "center",
          label: "供应商名称",
          prop: "supplierName",
        },
        {
          width: 100,
          align: "center",
          label: "商品类型",
          prop: "goodsType",
        },
        {
          width: 100,
          align: "center",
          label: "商品名称",
          prop: "goodsName",
        },
        {
          width: 100,
          align: "center",
          label: "生产厂家",
          prop: "factory",
        },
        {
          width: 100,
          align: "center",
          label: "商品规格",
          prop: "specification",
        },
        {
          width: 100,
          align: "center",
          label: "商品单价（元）",
          prop: "price",
        },
        {
          width: 100,
          align: "center",
          label: "采购数量",
          prop: "purchaseQuantity",
        },
        {
          width: 100,
          align: "center",
          label: "采购总金额（元）",
          prop: "purchaseTotalAmount",
        },
        {
          width: 50,
          align: "center",
          label: "售后数量",
          prop: "afterSaleQuantity",
        },

        {
          width: 100,
          align: "center",
          label: "售后总金额（元）",
          prop: "afterSaleTotalAmount",
        },
        {
          width: 100,
          align: "center",
          label: "单个商品收入（元）",
          prop: "unitPrice",
        },
        {
          width: 100,
          align: "center",
          label: "售后共减少金额（元）",
          prop: "afterSaleTotalIncome",
        },
        {
          width: 100,
          align: "center",
          label: "商家优惠金额（元）",
          prop: "realityPrice",
        },
        {
          width: 100,
          align: "center",
          label: "平台补贴（元）",
          prop: "platformSubsidyPrice",
        },
        {
          width: 100,
          align: "center",
          label: "平台代金券",
          prop: "subsidyAmount",
        },
        {
          width: 100,
          align: "center",
          label: "缴费前收入（元）",
          prop: "incomeBeforePayment",
        },
        {
          width: 100,
          align: "center",
          label: "技术服务费（元）",
          prop: "platformServiceMoney",
        },
        {
          width: 100,
          align: "center",
          label: "推广服务费（元）",
          prop: "promotionMoney",
        },
        {
          width: 100,
          align: "center",
          label: "缴费总金额（元）",
          prop: "totalPayment",
        },
        {
          width: 100,
          align: "center",
          label: "收入结算金额（元）",
          prop: "revenueSettlementAmount",
        },
        {
          width: 100,
          align: "center",
          label: "缴费状态",
          prop: "payFeesStatus",
          slot: true,
        },
        {
          width: 160,
          align: "center",
          label: "订单编号",
          prop: "orderCode",
        },
        {
          width: 160,
          align: "center",
          label: "下单时间",
          prop: "orderTime",
        },
        {
          width: 160,
          align: "center",
          label: "完成收货时间",
          prop: "finishDate",
        },
        {
          width: 100,
          align: "center",
          label: "订单状态",
          prop: "orderStatus",
          slot: true,
        },
      ],
      tableData: [],
      supplierIds: [], // 供应商id
      clientIds: [], // 客户id
      businessType: "", // 商品类型
      noticeArr: [],
      noticeCount: 0,
    };
  },
  created() {
    this.requestData();
    this.getProvince();
    // 查询高度
    this.$nextTick(() => {
      const containerHeight = this.$refs.containerRef.offsetHeight;
      const searchBoxHeight = this.$refs.searchBoxRef.offsetHeight;
      this.tableBoxHeight =
        containerHeight - searchBoxHeight - 12 - 12 - 35 - 24;
    });
  },
  methods: {
    countNotices(item) {
      const {
        total = 0,
        orderAllAmount = 0,
        afterSaleAllAmount = 0,
        platformServiceAllMoney = 0,
        promotionAllMoney = 0,
        totalAllPayment = 0,
        revenueSettlementAllAmount = 0,
      } = item;
      // 计算订单总金额 售后总金额 技术服务费 推广服务费 缴费总金额 收入结算金额
      try {
        const sums = {
          purchaseTotalAmount: 0,
          afterSaleTotalAmount: 0,
          platformServiceMoney: 0,
          promotionMoney: 0,
          totalPayment: 0,
          // revenueSettlementAmount: 0,
        };
        sums.purchaseTotalAmount = orderAllAmount;
        sums.afterSaleTotalAmount = afterSaleAllAmount;
        sums.platformServiceMoney = platformServiceAllMoney;
        sums.promotionMoney = promotionAllMoney;
        sums.totalPayment = totalAllPayment;
        // sums.revenueSettlementAmount = revenueSettlementAllAmount;
        this.noticeArr = Object.entries(sums).map(([key, value]) => {
          const titles = {
            purchaseTotalAmount: "订单总金额",
            afterSaleTotalAmount: "售后总金额",
            platformServiceMoney: "技术服务费",
            promotionMoney: "推广服务费",
            totalPayment: "缴费总金额",
            // revenueSettlementAmount: "收入结算金额",
          };
          return {
            title: titles[key],
            price: value.toFixed(2),
          };
        });
        this.noticeCount = total;
      } catch (error) {
        console.error("计算总金额时发生错误:", error);
      }
    },
    getProvince() {
      regionProvince().then((res) => {
        if (res.code === 0) {
          this.provinceData = res.data;
        }
      });
    },
    provinceBtn(item) {
      this.cityData = [];
      this.areaData = [];
      if (!item) {
        this.city = "";
        this.area = "";
      } else {
        regionCity(item).then((res) => {
          this.cityData = res.data;
          this.city = "";
          this.area = "";
        });
      }
    },
    cityBtn(item) {
      this.areaData = [];
      if (!item) {
        this.area = "";
      } else {
        regionArea(item).then((res) => {
          this.area = "";
          this.areaData = res.data;
        });
      }
    },
    areaBtn(item) {
      if (!item) {
        this.area = "";
      }
    },
    pendingParams() {
      const provinceItem = this.provinceData.find(
        (item) => item.id === this.province
      );
      const cityItem = this.cityData.find(
        (item) => item.id === this.city
      );
      const areaItem = this.areaData.find(
        (item) => item.id === this.area
      );
      const obj = {
        current: this.page.current,
        size: this.page.size,
        clientName: this.clientName,
        provinceName: provinceItem ? provinceItem.rname : "",
        cityName: cityItem ? cityItem.rname : "",
        areaName: areaItem ? areaItem.rname : "",
        supplierName: this.supplierName,
        goodsName: this.goodsName,
        orderCode: this.orderCode,
        orderStatus: this.orderStatus,
        settleAccountStatus: this.settleAccountsStatus,
        payFeeStatus: this.payFeesStatus,
        typeCode: this.clientIds,
        supplierIds: this.supplierIds,
        businessType: this.businessType,
      };
      if (this.orderDate && this.orderDate.length > 0) {
        obj.orderStartTime = dayjs(this.orderDate[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        obj.orderEndTime = dayjs(this.orderDate[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      if (this.finishDate && this.finishDate.length > 0) {
        obj.finishStartTime = dayjs(this.finishDate[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        obj.finishEndTime = dayjs(this.finishDate[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      return obj;
    },
    // 请求数据
    requestData() {
      this.loading = true;
      const obj = this.pendingParams();
      queryProductMonthlyStatementPage(obj)
        .then((res) => {
          const { records, total, current } = res;
          this.tableData = records || [];
          this.page.total = total || 0;
          this.page.current = current || 1;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          // loading.close();
          this.loading = false;
        });
      queryProductMonthlyStatementCollect(obj)
        .then((res) => {
          if (res) {
            this.countNotices(res);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 搜索
    handleSearch() {
      console.log(
        this.payShopName,
        this.supplierName,
        this.orderCode,
        this.orderStatus,
        this.settleAccountsStatus,
        this.payFeesStatus,
        this.orderDate,
        this.finishDate
      );
      this.page.current = 1;
      this.requestData();
    },
    // 重置
    handleReset() {
      this.clientName = "";
      this.province = "";
      this.city = "";
      this.area = "";
      this.cityData = [];
      this.areaData = [];
      this.supplierName = "";
      this.goodsName = "";
      this.orderCode = "";
      this.orderStatus = "";
      this.settleAccountsStatus = "";
      this.payFeesStatus = "";
      this.orderDate = "";
      this.finishDate = "";
      this.page.current = 1;
      this.page.size = 20;
      this.supplierIds = [];
      this.clientIds = [];
      this.businessType = "";
      this.requestData();
    },
    // 导出
    handleExport() {
      const obj = this.pendingParams();
      productMmonthlyStatementExport(obj)
        .then((res) => {
          const { data } = res;
          if (data && data.size) {
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", "商品对账单.xlsx");
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 分页
    handlePageChange(page) {
      this.page.current = page;
      this.requestData();
    },
    handleSizeChange(size) {
      this.page.size = size;
      this.page.current = 1;
      this.requestData();
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  background-color: #ffffff;
  padding: 12px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #c0c4cc;
    border-radius: 5px;
    &:hover {
      background-color: #909399;
    }
  }
  &::-webkit-scrollbar-track {
    background-color: #f5f7fa;
  }
  .search-box {
    display: flex;
    align-items: center;
    .search-form {
      display: flex;
      flex: 1;
    }
    .search-btn {
      width: 200px;
    }
  }
  .table-box {
    display: flex;
    flex: 1;
    .el-table {
      width: 100%;
    }
    ::v-deep .el-table__body-wrapper {
      &::-webkit-scrollbar {
        width: 10px;
        height: 10px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #c0c4cc;
        border-radius: 5px;
        &:hover {
          background-color: #909399;
        }
      }
      &::-webkit-scrollbar-track {
        background-color: #f5f7fa;
      }
    }
  }
  .pagination-box {
    text-align: center;
  }
}
</style>
